export const userName = state => state.userName // 获取userName
export const userCode = state => state.userCode // 获取userCode
export const partNo = state => state.partNo // 获取零件ID
export const cshPicker = state => state.cshPicker // 获取CSHID
export const orderStatusList = state => state.orderStatusList // 获取订单状态筛选LIST
export const name = state => state.name // 设定订单状态筛选Index
export const userType = state => state.userType // 获取用户类型筛选
export const userTypeIndex = state => state.userTypeIndex// 设定用户类型筛选Index
export const showPersonalFlg = state => state.showPersonalFlg// 设定显示个人用户筛选Index
export const searchContent = state => state.searchContent// 库存查询的的搜索内容

